import script from "./SurveyFreeResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyFreeResult.vue?vue&type=script&setup=true&lang=js"

import "./SurveyFreeResult.vue?vue&type=style&index=0&id=08435b8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08435b8e"]])

export default __exports__